<script>
export default {
  name: 'TotalBlock',
  components: {},
  props: {
    label: {
      type: String,
      default: '合计'
    }
  },
  data() {
    return {
      
    };
  },
  computed: {
    
  },
  watch: {},
  mounted() {
    
  },
  methods: {
    
  }
}
</script>

<template>
  <div class="total-block">
    <div v-if="label" class="total-block__label">{{ label }}</div>
    <div class="flex flex-direction gap total-block__body">
      <slot name="default"></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.total-block {
  border-radius: 4px;
  background: var(--color-fill-2);
  width: 100%;

  display: flex;

  padding: 20px;

  .total-block__label {
    width: 100px;
    color: var(--color-text-1);
  }

  .total-block__body {
    width: 100%;
  }
}
</style>